/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: Knowit
// License: CC-BY 4.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const ListAlphabetical = (props: Props): JSX.Element => (
  <Icon viewBox="0 0 38.4 32.3" {...props}>
    <path d="M10.4 2.1h28v4h-28zm0 24h28v4h-28zm0-12h28v4h-28zM2.5 6.5h2.1l.6 1.7h2L4.3 0H2.8L0 8v.2h2Zm.4-1.8.7-2.1.7 2.1Zm3.4 10.8a1.7 1.7 0 0 0 .3-1 2.7 2.7 0 0 0-.6-1.7 3 3 0 0 0-1.8-.7H1v8.1h3.4a2.2 2.2 0 0 0 1.7-.7 2.4 2.4 0 0 0 .7-1.8 3 3 0 0 0-.3-1.3 1.2 1.2 0 0 0-.5-.5zM2.8 17h1.3l.6.2a1.4 1.4 0 0 1 .2.6 1 1 0 0 1-.2.5l-.6.2H2.8Zm1.8-1.9-.6.2H2.8v-1.4H4l.6.2a1 1 0 0 1 .2.5zm.2 14.5a1 1 0 0 1-1 .8h-.5l-.3-.3a.5.5 0 0 1-.2-.4 7 7 0 0 1-.1-1.4 7 7 0 0 1 .1-1.4.5.5 0 0 1 .2-.4l.3-.3h.5l.6.2.4.6h1.9v-.5a3 3 0 0 0-.9-1.8 3 3 0 0 0-2-.7 3 3 0 0 0-1.6.5 3 3 0 0 0-.9 1l-.3.8a11 11 0 0 0-.1 1.8 11 11 0 0 0 .1 1.8l.1.5c0 .2.1.2.2.3a2.4 2.4 0 0 0 1 1 3 3 0 0 0 1.6.5 3.3 3.3 0 0 0 1.9-.6 2.5 2.5 0 0 0 1-1.8v-.5H5Z" />
  </Icon>
);
